import React from 'react';
import { observer } from 'mobx-react-lite';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import CopilotHeader from './CopilotHeader/CopilotHeader';
import CopilotBody from './CopilotBody/CopilotBody';
import { useStore } from '@/components/../stores';

import './SolgariCopilot.scss';

const antIcon = <LoadingOutlined spin />;

const SolgariCopilot = observer(() => {
  const {
    transcriptStore: { isLoading, currentSessionsAnalytics },
  } = useStore();

  if (isLoading) {
    return (
      <div className="spinner__wrapper">
        <Spin className="spinner" indicator={antIcon} />
      </div>
    );
  }

  if (!currentSessionsAnalytics) {
    return (
      <div className="error__wrapper">
        <div className="error__text">
          Can`t found or load transcript analytics
        </div>
      </div>
    );
  }

  return (
    <div className="solgari-copilot-card-wrapper">
      <CopilotHeader />
      <CopilotBody />
    </div>
  );
});

export default SolgariCopilot;
